// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"jWThf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
const Footer = /*#__PURE__*/ (0, _react.lazy)(()=>require("d666fb4af2d2319d"));
const Header = /*#__PURE__*/ (0, _react.lazy)(()=>require("ca52fd0d64035cbc"));
const Layout = ({ children })=>{
    const location = (0, _reactRouterDom.useLocation)();
    const squaresLocation = location.pathname === "/squares";
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "c8Page justify-center w-full",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Header, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                id: "mainMenu",
                className: "w-full mx-auto px-0 lg:w-full",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("main", {
                    children: children
                })
            }),
            !squaresLocation ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(Footer, {}) : ""
        ]
    });
};
exports.default = Layout;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","d666fb4af2d2319d":"cOjok","ca52fd0d64035cbc":"j157c","@parcel/transformer-js/src/esmodule-helpers.js":"k3151","react-router-dom":"l6ORY"}],"cOjok":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("36e284b11827a80f")(require("3d661bda8627ed35").resolve("7CnJa")),
    require("36e284b11827a80f")(require("3d661bda8627ed35").resolve("18aVi"))
]).then(()=>module.bundle.root('fXyyO'));

},{"36e284b11827a80f":"hpx0h","3d661bda8627ed35":"fyJL2"}],"j157c":[function(require,module,exports,__globalThis) {
module.exports = require("cf66c37b5c88cf8")(require("2b59aac03ca405f6").resolve("2yTRz")).then(()=>module.bundle.root('j9WOY'));

},{"cf66c37b5c88cf8":"hpx0h","2b59aac03ca405f6":"fyJL2"}]},[], null, "parcelRequire94c2")

//# sourceMappingURL=Layout.cd3554f7.js.map
